import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { GlgTooltip } from 'Shared/components'
import { selectCustomerDateFormat } from '../../reducers/session_saver'
import { getDateOnlyUnixFormat } from 'Shared/date_time_format'

const LeagueRoundsTooltipChip = ({ league }) => {
  const customerDateFormat = useSelector(selectCustomerDateFormat)
  const formatDate = (playAt) => moment(playAt).format(getDateOnlyUnixFormat(customerDateFormat))

  if (!league?.first_round?.playAt || !league?.last_round?.playAt) {
    return null
  }

  const text = (league?.total_rounds > 1) ? window.I18n.t(
    'clone_leagues_sessions.leagues_search.first_last_round_tooltip',
    { first_round: formatDate(league.first_round.playAt), last_round: formatDate(league.last_round.playAt) },
  ) : window.I18n.t(
    'clone_leagues_sessions.leagues_search.only_round_tooltip',
    { round: formatDate(league.first_round.playAt) },
  )

  return (<GlgTooltip tooltip={text}>
   <span className='cls-lb-rounds-tooltip-chip'>
     <span>R1</span>
     <span>{formatDate(league.first_round.playAt)}</span>
   </span>
  </GlgTooltip>)
}

LeagueRoundsTooltipChip.propTypes = {
  league: PropTypes.shape({
    total_rounds: PropTypes.number,
    first_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
    last_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
  }),
}
export default LeagueRoundsTooltipChip
